import { call, put, takeLatest } from "redux-saga/effects";
import { httpGetFeedback } from "../../../services/feedback";
import {
  getFeedbackFailure,
  getFeedbackStart,
  getFeedbackSuccess,
} from "../reducer";

export function* getFeedback({ payload }) {
  const response = yield call(httpGetFeedback, payload);
  const { success, raw, message } = response;

  if (success) {
    yield put(getFeedbackSuccess(raw));
  } else {
    yield put(getFeedbackFailure(message || raw.error));
  }
}

export default function* onGetFeedback() {
  yield takeLatest(getFeedbackStart.type, getFeedback);
}
